import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  BackendService,
  HttpOptions,
  PaginatedResponseModel,
} from '@ipg/ngx-frontend-toolset';
import { Device } from '../models/devices.model';

@Injectable({
  providedIn: 'root',
})
export class DevicesService {
  private readonly _backend = inject(BackendService);

  update(id: string, data: { label: string }, options?: HttpOptions): Observable<void> {
    return this._backend.put(`/devices/${id}`, data, options);
  }

  getAll(options?: HttpOptions): Observable<PaginatedResponseModel<Device[]>> {
    return this._backend.get(`/devices`, options);
  }

  attach(data: unknown, options?: HttpOptions) {
    return this._backend.post(`/devices/attach`, data, options);
  }

  detach(id: string, options?: HttpOptions) {
    return this._backend.put(`/devices/${id}/detach`, null, options);
  }

  transfer(deviceId: string, targetUnitId: string, options?: HttpOptions) {
    return this._backend.put(
      `/devices/${deviceId}/transfer/${targetUnitId}`,
      null,
      options
    );
  }
}
